import { useSelector } from 'react-redux';
import { selectChannel } from 'app/store/channelsSlice';
import { selectEntryById } from 'app/store/groupsSlice';
import SidebarListItem from 'app/shared-components/layout/SidebarListItem';

function TopicSidebarListItem(props) {
  const { groupId, topicId, onClick, type, registerPath } = props;
  const topic = useSelector(selectChannel(topicId));
  const entry= useSelector(selectEntryById(topicId));
  const unread= entry && entry.unread;
  
  if (!topic) return null;

  return (
	  <SidebarListItem link={"/apps/" + type + "/" + groupId + "/channel/" + topicId}
           			   key={topicId}
           			   icon="heroicons-outline:chat-bubble-bottom-center-text"
           			   text={topic.name}
           			   onClick={onClick}
                       registerPath={registerPath}
           			   unread={unread}/>
  );
}

export default TopicSidebarListItem;
